import moment from "moment";
import { useContext } from "react";
import { CustomizationContext } from "./CustomizationContext";
import { buildIngredientInputMap, getCustomizationFieldName } from "./CustomizeModal-utils";
import { matchPath, useLocation } from "react-router-dom";
import { getCurrentMealFromCart } from "../../utils/getCurrentMealFromCart";
import { getOrderFlowRecipeAssignments } from "../../utils/getOrderFlowRecipeAssignments";
export const useCustomization = (date, recipe, programMealId, ingredientsToReplace, customizationsOptionsSubtext) => {
    var _a;
    const { meals, days, day, assignmentId, quantity, isAddDisabled, setIsAddDisabled, setQuantity } = useContext(CustomizationContext);
    const location = useLocation();
    const isOrderFlow = matchPath({ path: "/:sku/OrderFlow" }, location.pathname);
    const isCheckout = matchPath({ path: "/:sku/Checkout" }, location.pathname);
    const currentMeal = getCurrentMealFromCart(meals, date, programMealId);
    const orderFlowRecipeAssignments = getOrderFlowRecipeAssignments(currentMeal, recipe, programMealId, date);
    const myMealsRecipeAssignments = (_a = day === null || day === void 0 ? void 0 : day.Recipes.find((r) => r.ProgramMealId === (recipe === null || recipe === void 0 ? void 0 : recipe.ProgramMealId) && r.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId))) === null || _a === void 0 ? void 0 : _a.Assignments;
    const currentRecipeAssignments = !!isOrderFlow || !!isCheckout ? orderFlowRecipeAssignments : myMealsRecipeAssignments;
    const ingredientInputMap = buildIngredientInputMap(ingredientsToReplace, customizationsOptionsSubtext);
    //Find the recipe assignment that was clicked in the Customize tab
    const currentRecipeAssignment = currentRecipeAssignments === null || currentRecipeAssignments === void 0 ? void 0 : currentRecipeAssignments.find((r) => r.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId) &&
        r.ProgramMealId === programMealId &&
        (isOrderFlow ? moment(r.Date).isSame(date, "date") : true) &&
        r.AssignmentId === assignmentId);
    const ingredientOptions = ingredientsToReplace
        ? ingredientsToReplace.map((ing) => getCustomizationFieldName(ing))
        : [];
    return {
        isAddDisabled,
        setIsAddDisabled,
        currentRecipeAssignment,
        meals,
        ingredientOptions,
        days,
        quantity,
        ingredientInputMap,
        setQuantity
    };
};
